import { _ as a } from "./_ListCache.js";
var t = a;
function s() {
  this.__data__ = new t(), this.size = 0;
}
var e = s;
export {
  e as _
};
//# sourceMappingURL=_stackClear.js.map
